import React from 'react';
import { FONT, WHITE } from '../../../shared';
import { getCssAspect } from '../../../lib/aspectRatioMatrix';

// YT_Short_9x16 — YouTube Shorts vertical player chrome
// Reference: Vella_Preview_Mockup_Spec.md §4.11
// Full-screen 9:16 · channel + subscribe · right-side action rail · bottom title + music
export default function YouTubeShortChrome({
  assetUrl,
  title = "Watch what happened next",
  hashtags = [],
  channelName = "your_brand",
  channelAvatarUrl,
  likeCount = "84K",
  dislikeCount = "Dislike",
  commentCount = "1.2K",
  shareCount = "Share",
  remixCount = "Remix",
  musicTitle = "Original audio · your_brand",
}) {
  const ratio = getCssAspect("YouTube", "Short");
  const hashtagLine = hashtags.length ? " " + hashtags.map(h => `#${h.replace(/^#/, '')}`).join(" ") : "";

  return (
    <div style={{ fontFamily: FONT, width: "100%", maxWidth: 390, borderRadius: 18, overflow: "hidden", background: "#000000", color: WHITE, position: "relative" }}>
      <div style={{ width: "100%", aspectRatio: ratio, background: "#111", position: "relative", overflow: "hidden" }}>
        {assetUrl && <img src={assetUrl} alt="short" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />}

        {/* Bottom legibility gradient */}
        <div style={{ position: "absolute", left: 0, right: 0, bottom: 0, height: "42%", background: "linear-gradient(to top, rgba(0,0,0,0.78), rgba(0,0,0,0))" }} />

        {/* Top bar */}
        <div style={{ position: "absolute", top: 14, left: 14, right: 14, display: "flex", justifyContent: "space-between", alignItems: "center", zIndex: 3, textShadow: "0 1px 2px rgba(0,0,0,0.6)" }}>
          <span style={{ fontSize: 17, fontWeight: 700 }}>Shorts</span>
          <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden><circle cx="11" cy="11" r="7" /><path d="M21 21l-4.35-4.35" /></svg>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden><circle cx="12" cy="12" r="1" /><circle cx="12" cy="6" r="1" /><circle cx="12" cy="18" r="1" /></svg>
          </div>
        </div>

        {/* Right-side action rail */}
        <div style={{ position: "absolute", right: 8, bottom: 96, display: "flex", flexDirection: "column", alignItems: "center", gap: 18, zIndex: 3, textAlign: "center", textShadow: "0 1px 2px rgba(0,0,0,0.5)" }}>
          {/* Like */}
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
            <div style={{ width: 44, height: 44, borderRadius: "50%", background: "rgba(255,255,255,0.14)", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="#FFFFFF" aria-hidden><path d="M2 9h4v12H2zM22 10a2 2 0 00-2-2h-5.5l.9-4.5a1.5 1.5 0 00-2.8-1L8 9v12h11.3a2 2 0 002-1.6L22 10z" /></svg>
            </div>
            <span style={{ fontSize: 11, fontWeight: 600 }}>{likeCount}</span>
          </div>

          {/* Dislike */}
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
            <div style={{ width: 44, height: 44, borderRadius: "50%", background: "rgba(255,255,255,0.14)", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="#FFFFFF" aria-hidden><path d="M2 3h4v12H2zM22 14a2 2 0 01-2 2h-5.5l.9 4.5a1.5 1.5 0 01-2.8 1L8 15V3h11.3a2 2 0 012 1.6L22 14z" /></svg>
            </div>
            <span style={{ fontSize: 11, fontWeight: 600 }}>{dislikeCount}</span>
          </div>

          {/* Comment */}
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
            <div style={{ width: 44, height: 44, borderRadius: "50%", background: "rgba(255,255,255,0.14)", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="#FFFFFF" aria-hidden><path d="M21 11.5a8.4 8.4 0 01-1 4 8.5 8.5 0 01-7.6 4.7 8.4 8.4 0 01-4-1L3 21l1.9-5.4a8.4 8.4 0 01-1-4A8.5 8.5 0 0112.5 3a8.5 8.5 0 018.5 8.5z" /></svg>
            </div>
            <span style={{ fontSize: 11, fontWeight: 600 }}>{commentCount}</span>
          </div>

          {/* Share */}
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
            <div style={{ width: 44, height: 44, borderRadius: "50%", background: "rgba(255,255,255,0.14)", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden><path d="M4 12v7a2 2 0 002 2h12a2 2 0 002-2v-7" /><path d="M16 6l-4-4-4 4" /><path d="M12 2v14" /></svg>
            </div>
            <span style={{ fontSize: 11, fontWeight: 600 }}>{shareCount}</span>
          </div>

          {/* Remix */}
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
            <div style={{ width: 44, height: 44, borderRadius: "50%", background: "rgba(255,255,255,0.14)", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden><path d="M3 6h18M3 12h18M3 18h18" /><circle cx="6" cy="6" r="2" fill="#FFFFFF" /><circle cx="18" cy="18" r="2" fill="#FFFFFF" /></svg>
            </div>
            <span style={{ fontSize: 11, fontWeight: 600 }}>{remixCount}</span>
          </div>

          {/* Spinning music disc */}
          <div style={{ width: 36, height: 36, borderRadius: "50%", background: channelAvatarUrl ? `center/cover url(${channelAvatarUrl})` : "conic-gradient(#444,#fff,#444)", border: "2px solid white", animation: "spin 8s linear infinite" }} />
        </div>

        {/* Bottom-left content block */}
        <div style={{ position: "absolute", bottom: 60, left: 14, right: 76, zIndex: 3, textShadow: "0 1px 2px rgba(0,0,0,0.6)" }}>
          {/* Channel + subscribe */}
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
            <div style={{ width: 32, height: 32, borderRadius: "50%", background: channelAvatarUrl ? `center/cover url(${channelAvatarUrl})` : "linear-gradient(135deg,#FF0000,#9B0000)", color: WHITE, fontSize: 13, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
              {!channelAvatarUrl && channelName.charAt(0).toUpperCase()}
            </div>
            <span style={{ fontSize: 14, fontWeight: 700 }}>@{channelName}</span>
            <button type="button" style={{ marginLeft: 4, height: 30, padding: "0 14px", borderRadius: 999, background: "#FF0000", color: WHITE, fontSize: 12, fontWeight: 700, border: 0, cursor: "pointer" }}>
              Subscribe
            </button>
          </div>

          {/* Title + hashtags */}
          <div style={{ fontSize: 13, lineHeight: 1.4, marginBottom: 8 }}>
            {title}{hashtagLine && <span style={{ opacity: 0.95 }}>{hashtagLine}</span>}
          </div>

          {/* Music row */}
          <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, opacity: 0.95 }}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="#FFFFFF" aria-hidden><path d="M9 17V7l10-2v10a3 3 0 11-2-2.8V7.6L11 9v8a3 3 0 11-2-2.8V17z" /></svg>
            <span>{musicTitle}</span>
          </div>
        </div>

        {/* Bottom tab bar */}
        <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, height: 48, display: "flex", justifyContent: "space-around", alignItems: "center", background: "rgba(0,0,0,0.55)", color: WHITE, zIndex: 3 }}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden><path d="M3 12l9-9 9 9v9a2 2 0 01-2 2h-4v-7H10v7H6a2 2 0 01-2-2v-9z" /></svg>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden><path d="M10 4l8 8-8 8V4z" opacity="0.95" /></svg>
          <div style={{ width: 30, height: 30, borderRadius: 6, border: "2px solid #FFFFFF", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18, fontWeight: 300, lineHeight: 1 }}>+</div>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden><path d="M21 11.5V18a2 2 0 01-2 2H5a2 2 0 01-2-2v-6.5l9-7 9 7z" /></svg>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden><circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0116 0" /></svg>
        </div>

        {/* Progress scrubber */}
        <div style={{ position: "absolute", bottom: 48, left: 0, right: 0, height: 1.5, background: "rgba(255,255,255,0.2)", zIndex: 3 }}>
          <div style={{ height: "100%", width: "32%", background: "#FF0000" }} />
        </div>
      </div>
    </div>
  );
}
